import React from 'react';
import moment from 'moment';
import '../utility/styles/print.css';

const getCompanyDetails = () => {
  try {
    return JSON.parse(localStorage.getItem('companyDetails')) || {};
  } catch (error) {
    return {};
  }
};

const PrintBookingHistory = React.forwardRef((props, ref) => {
  const { data, firstDate, SecondDate, bookingCustomerDetails } = props;
  const company = getCompanyDetails();
  const companyName =
    company.companyName ||
    company.company_name ||
    localStorage.getItem('company') ||
    'Company';
  const companyAddress = [
    company.address,
    company.city,
    company.state,
    company.pinCode || company.pin_code || company.pincode,
  ]
    .filter(Boolean)
    .join(', ');
  const companyContact = [
    company.mobile && `Phone: ${company.mobile}`,
    company.email && `Email: ${company.email}`,
  ]
    .filter(Boolean)
    .join('  •  ');
  const customerFilter = [
    bookingCustomerDetails?.customer_name,
    bookingCustomerDetails?.mobile,
  ]
    .filter(Boolean)
    .join(' • ');
  const formatDate = (value) =>
    value ? moment(value).format('DD-MM-YYYY') : '—';

  return (
    <div ref={ref} id="booking-history-print" className="bill-summary-print">
      <table className="bill-summary-print-table">
        <colgroup>
          {[8, 13, 10, 9, 9, 7, 9, 9, 8, 9, 9].map(
            (columnWidth, index) => (
              <col key={index} style={{ width: `${columnWidth}%` }} />
            )
          )}
        </colgroup>
        <thead>
          <tr>
            <th colSpan="11" className="print-company-header">
              <div className="print-company-name">{companyName}</div>
              {companyAddress && (
                <div className="print-company-detail">{companyAddress}</div>
              )}
              {companyContact && (
                <div className="print-company-detail">{companyContact}</div>
              )}
              <div className="print-report-heading">
                <span>Booking History</span>
                <span>
                  {moment(firstDate).format('DD MMM YYYY')} –{' '}
                  {moment(SecondDate).format('DD MMM YYYY')}
                </span>
              </div>
              <div className="print-report-meta">
                <span>{customerFilter || 'All customers'}</span>
                <span>{data.length} booking(s)</span>
              </div>
            </th>
          </tr>
          <tr className="print-column-header">
            <th>Date</th>
            <th>Customer</th>
            <th>Mobile</th>
            <th>Mobile 2</th>
            <th>Phone</th>
            <th>MRC No.</th>
            <th>Booking Order</th>
            <th>State</th>
            <th>Try Date</th>
            <th>Delivery Date</th>
            <th>Cutting Date</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={`${row.BOOKING_ORDER_NO}-${index}`}>
              <td className="print-center">{formatDate(row.DATE)}</td>
              <td>{row.CUSTOMER_NAME || '—'}</td>
              <td className="print-center">{row.MOBILE || '—'}</td>
              <td className="print-center">{row.MOBILE_2 || '—'}</td>
              <td className="print-center">{row.MOBILE_3 || '—'}</td>
              <td className="print-center">{row.MRC_NO || '—'}</td>
              <td className="print-center">
                {row.BOOKING_ORDER_NO || '—'}
              </td>
              <td>{row.STATE || '—'}</td>
              <td className="print-center">{formatDate(row.TRY_DATE)}</td>
              <td className="print-center">{formatDate(row.DEL_DATE)}</td>
              <td className="print-center">
                {formatDate(row.CUTTING_DATE)}
              </td>
            </tr>
          ))}
          <tr className="print-total-row">
            <td colSpan="11" className="print-total-label">
              Total Bookings: {data.length}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
});

export default PrintBookingHistory;
